<!-- client\src\views\Dashboard.vue -->
<template>
  <div>
    <h1 class="text-h4 mb-4">My Aquariums</h1>
    <v-container>
      <v-card v-if="showEmptyListMessage" class="mx-auto mb-8 text-center" max-width="500">
        <v-card-title class="text-h5">No Aquariums Found!</v-card-title>
        <v-card-text>Click the button below to create a new aquarium.</v-card-text>
        <v-card-actions class="justify-center">
          <v-btn variant="elevated" color="primary" @click="openNewAquariumModal">Create New Aquarium</v-btn>
        </v-card-actions>
      </v-card>
      <v-row>
        <v-col
          v-for="aquarium in aquariums"
          :key="aquarium.id"
          sm="6"
          md="4"
          lg="3"
        >
          <aquarium-card :aquarium="aquarium" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios';
import newaquariumimage from '@/assets/addnewaquarium.png';
import AquariumCard from '../components/AquariumCard.vue';
import { useAuthStore } from "@/store";
import { usePopupStore } from "@/store";
import { useModalStore } from "@/store";
import { useHead } from '@vueuse/head';

export default {
  name: 'Dashboard',
  components: {
    AquariumCard,
  },
  setup() {
    const authStore = useAuthStore();
    const popupStore = usePopupStore();
    const modalStore = useModalStore();

    useHead({
      title: 'Reeflendar.com - Dashboard',
      meta: [
        { name: 'description', content: 'Your personal aquarium dashboard.' },
        { name: 'keywords', content: 'aquarium, dashboard, logs, images' },
      ],
    });

    return {
      authStore,
      popupStore,
      modalStore,
    };
  },
  data() {
    return {
      aquariums: [],
    };
  },
  mounted() {
    this.fetchAquariums();
    
  },
  computed: {
    showEmptyListMessage() {
      return this.aquariums.length === 1;   //=== 1 because the new aquarium card is added which counts as an aquarium
    }
  },
  methods: {
    async fetchAquariums() {
      try {
        const response = await axios.get('/api/aquariums/');
        this.aquariums = response.data;
        this.addNewAquariumCard();
      } catch (error) {
        this.popupStore.setMessage('Error fetching aquarium', error.message);
      }
    },
    addNewAquariumCard() {
      this.aquariums.push({
        id: 'new',
        name: 'New Aquarium',
        description: 'Create a new aquarium',
        image_url: newaquariumimage,
      });
    },
    openNewAquariumModal() {
      this.modalStore.openNewAquariumModal({
        mode: 'user',
        verb: 'create',
        prefilledData: { 
          name:'',
          user_id: this.authStore.user.id,
        }
      });
    },
  },
};
</script>